var React = require('react');

function Available (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"6","cy":"6","r":"6","fill":"#0BCE5A"}));
}

Available.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Available;

Available.default = Available;
